import { Component, Input } from '@angular/core';
import { EYesNo } from '../../../../shared/models/types.enum';
import { ParentInterviewService } from '../../../../shared/services/parentInterview.service';
import { CommonModule } from '@angular/common';
import { SpinnerComponent } from '../../spinner/spinner.component';

@Component({
  selector: 'review-parent-interview',
  standalone: true,
  imports: [
    CommonModule,
    SpinnerComponent
  ],
  templateUrl: './review-parent-interview.component.html',
  styleUrl: './review-parent-interview.component.css'
})
export class ReviewParentInterviewComponent {
  
  @Input() caseId: string | null = null;
  
  yesNo = EYesNo;
  parentInterview: any | null = null;
  loading: boolean = false;
  
  sections = [
    {
      sectionName: "Parent Information",
      children: [
        {
          type: 'string',
          questionText: "Parent Name:",
          answer: "parent_name"
        },
        {
          type: 'date',
          questionText: "Date of Interview:",
          answer: "date_interview"
        },
        {
          type: 'string',
          questionText: "Time of Interview:",
          answer: "time_interview"
        },
        {
          type: 'string',
          questionText: "Person Conducting Interview:",
          answer: "person_conducting_interview"
        }
      ]
    },
    {
      sectionName: "Knowledge of Threat",
      children: [
        {
          type: 'number',
          questionText: "Have you heard he/she talk about things like this before?",
          answer: 'student_talking'
        },
        {
          type: 'string',
          questionText: "If yes, please explain:",
          answer: 'student_talking_information'
        },
        {
          type: 'number',
          questionText: "Does he/she have the resources to carry out this threat?",
          answer: 'resources',
        },
        {
          type: 'number',
          questionText: "Are you familiar with the intended victim?",
          answer: 'intended_victim'
        },
        {
          type: 'string',
          questionText: "If yes, please explain:",
          answer: 'intended_victim_information'
        },
        {
          type: 'string',
          questionText: "What do you know about the threatening situation?",
          answer: "knowledge_threat",
        },
        {
          type: 'string',
          questionText: "What are you planning to do about this situation?",
          answer: "plans",
        }
      ]
    },
    {
      sectionName: "School Adjustment",
      children: [
        {
          type: 'number',
          questionText: "Has your child ever been suspended or expelled from school?",
          answer: 'suspension'
        },
        {
          type: 'string',
          questionText: "If yes, please explain:",
          answer: 'suspension_information'
        },
        {
          type: 'number',
          questionText: "Have you ever met with school personnel about concerns in the past?",
          answer: 'concerns_school_personnel'
        },
        {
          type: 'string',
          questionText: "If yes, please explain:",
          answer: 'concerns_school_personnel_information'
        },
        {
          type: 'string',
          questionText: "How does your child like school?",
          answer: "child_like_school",
        },
        {
          type: 'string',
          questionText: "How often does your child do homework?",
          answer: "child_homework",
        },
        {
          type: 'string',
          questionText: "What are your child's teachers like?",
          answer: "child_teacher",
        },
      ]
    },
    {
      sectionName: "Family Relationship",
      children: [
        {
          type: 'string',
          questionText: "Who lives in the home?",
          answer: "home_life",
        },
        {
          type: 'string',
          questionText: "Are there any important events that have affected your family or child such as:",
          answer: "important_events"
        },
        {
          type: 'string',
          questionText: "Who does your child talk to about concerns?",
          answer: "child_talk_concerns",
        },
        {
          type: 'string',
          questionText: "How well does he/she get along with you?",
          answer: "child_parent_relationship",
        },
        {
          type: 'string',
          questionText: "How well does he/she get along with siblings?",
          answer: "child_sibling_relationship"
        },
        {
          type: 'string',
          questionText: "How is conflict in the family usually resolved?",
          answer: "family_conflict"
        },
        {
          type: 'string',
          questionText: "How does your child show anger toward you and other family members?",
          answer: "child_anger"
        },
        {
          type: 'string',
          questionText: "What does your child do after school?",
          answer: "child_after_school"
        },
        {
          type: 'string',
          questionText: "Who supervises him/her?",
          answer: "supervision"
        },
        {
          type: 'string',
          questionText: "What time is he/she expected home?",
          answer: "home_expectation"
        },
        {
          type: 'string',
          questionText: "What responsibilities does your child have at home?",
          answer: "child_responsibilities"
        },
        {
          type: 'number',
          questionText: "Does your child follow rules?",
          answer: 'child_rules'
        },
        {
          type: 'string',
          questionText: "If no, please explain:",
          answer: 'child_rules_information'
        },
        {
          type: 'string',
          questionText: "What are the consequences for not following the rules?",
          answer: "consequences"
        },
      ]
    },
    {
      sectionName: "Peer Relationship",
      children: [
        {
          type: 'string',
          questionText: "Who are your child's friends?",
          answer: "child_friends",
        },
        {
          type: 'string',
          questionText: "How much is your child influenced by peers?",
          answer: "peer_influence",
        },
        {
          type: 'number',
          questionText: "Has your child reported being teased, intimidated, rejected or bullied?",
          answer: 'bully_report'
        },
        {
          type: 'string',
          questionText: "Please explain:",
          answer: 'bully_report_information'
        },
        {
          type: 'number',
          questionText: "Are you unpleased with your child's choice of friends?",
          answer: 'choice_friends'
        },
        {
          type: 'string',
          questionText: "Please explain:",
          answer: 'choice_friends_information'
        },
        {
          type: 'number',
          questionText: "Are there examples of your child doing something to please peers that caused him/her to be in trouble?",
          answer: 'examples'
        },
        {
          type: 'string',
          questionText: "Please explain:",
          answer: 'examples_information'
        },
      ]
    },
    {
      sectionName: "Problem Behavior",
      children: [
        {
          type: 'string',
          questionText: "What was the worst thing you know of that your child did?",
          answer: "worst_action",
        },
        {
          type: 'string',
          questionText: "How does your child handle frustration?",
          answer: "frustration",
        },
        {
          type: 'string',
          questionText: "When your child gets angry, what does he/she do?",
          answer: "child_anger_actions",
        },
        {
          type: 'number',
          questionText: 'Has your child been in trouble with the law or police before?',
          answer: 'trouble_law',
        },
        {
          type: 'string',
          questionText: "If yes, please explain:",
          answer: "trouble_law_information",
        },
        {
          type: 'number',
          questionText: 'Has your child done things that could have gotten him/her arrested or in trouble with the law?',
          answer: 'arrest'
        },
        {
          type: 'string',
          questionText: "If yes, please explain:",
          answer: "arrest_information",
        },
        {
          type: 'number',
          questionText: 'Are there other bad things?',
          answer: 'bad_things',
        },
        {
          type: 'string',
          questionText: "If yes, please explain:",
          answer: 'bad_things_information'
        },
        {
          type: 'number',
          questionText: 'Does your child drink beer, wine, or other alcohol?',
          answer: 'alcohol',
        },
        {
          type: 'string',
          questionText: "If yes, please explain:",
          answer: 'alcohol_information'
        },
        {
          type: 'number',
          questionText: 'Does your child use marijuana?',
          answer: 'drugs',
        },
        {
          type: 'string',
          questionText: "If yes, please explain:",
          answer: 'drugs_information'
        },
        {
          type: 'number',
          questionText: 'Has your child used any other drugs or medications not prescribed to him/her?',
          answer: 'medication',
        },
        {
          type: 'string',
          questionText: "If yes, please explain:",
          answer: 'medication_information'
        },
        {
          type: 'number',
          questionText: 'Has your child ever been involved in a fight?',
          answer: 'fight_involvement',
        },
        {
          type: 'string',
          questionText: "If yes, please explain:",          
          answer: 'fight_involvement',
        },
        {
          type: 'number',
          questionText: "Has your child's temper ever gotten him/her in trouble?",
          answer: 'child_temper',
        },
        {
          type: 'string',
          questionText: "If yes, please explain:",
          answer: 'child_temper_information'
        },
        {
          type: 'number',
          questionText: "Has your child ever hit you or other family members?",
          answer: 'child_hit_family',
        },
        {
          type: 'string',
          questionText: "If yes, please explain:",
          answer: 'child_hit_family_information'
        },
        {
          type: 'number',
          questionText: "Has your child destroyed his/her own things or something else's property?",
          answer: 'destroy_property',
        },
        {
          type: 'string',
          questionText: "If yes, please explain:",
          answer: 'destroy_property_information'
        },
        {
          type: 'number',
          questionText: "Does your child have pets?",
          answer: 'child_pets',
        },
        {
          type: 'string',
          questionText: "If yes, please explain:",
          answer: 'child_pets_information'
        },
        {
          type: 'number',
          questionText: "Has your child ever intentionally hurt a pet or other animal?",
          answer: 'hurt_animals',
        },
        {
          type: 'string',
          questionText: "If yes, please explain:",
          answer: 'hurt_animals_information'
        },
        {
          type: 'number',
          questionText: "Have you found items of concern in your child's room?",
          answer: 'items_of_concern',
        },
        {
          type: 'string',
          questionText: "If yes, please explain:",
          answer: 'items_of_concern_information'
        },
      ]
    },
    {
      sectionName: "Access to Weapons or Dangerous Items",
      children: [
        {
          type: 'string',
          questionText: "What can you do to restrict your child's access to weapons or dangerous items?",
          answer: "restrict_access",
        },
        {
          type: 'number',
          questionText: 'Do you have a gun or multiple guns in your home?',
          answer: 'own_guns',
        },
        {
          type: 'string',
          questionText: "If yes, please explain:",
          answer: 'own_guns_information'
        },
        {
          type: 'number',
          questionText: 'Does your child have access to firearms through friends, relatives, or some other source?',
          answer: 'firearms_relative',
        },
        {
          type: 'string',
          questionText: "If yes, please explain:",
          answer: 'firearms_relative_information'
        },
        {
          type: 'number',
          questionText: 'Does your child have access to weapons other than firearms, such as military knives, martial arts weapons, dangerous materials, or some other kind of weapon?',
          answer: 'military_weapons',
        },
        {
          type: 'string',
          questionText: "If yes, please explain:",
          answer: 'military_weapons_information'
        },
        {
          type: 'number',
          questionText: 'Has your child ever talked about using a weapon or dangerous material to hurt someone?',
          answer: 'hurt_someone',
        },
        {
          type: 'string',
          questionText: "If yes, please explain:",
          answer: 'hurt_someone_information'
        },
        {
          type: 'number',
          questionText: 'Has your child ever been in trouble for using a weapon, carrying a weapon, or threatening someone with a weapon?',
          answer: 'trouble_for_weapon',
        },
        {
          type: 'string',
          questionText: "If yes, please explain:",
          answer: 'trouble_for_weapon_information'
        },
      ]
    },
    {
      sectionName: "Exposure to Violence",
      children: [
        {
          type: 'number',
          questionText: 'Has your child ever been the victim of abuse?',
          answer: 'victim_of_abuse',
        },
        {
          type: 'string',
          questionText: "If yes, please explain:",
          answer: 'victim_of_abuse_information'
        },
        {
          type: 'number',
          questionText: 'Is your child exposed to violence in your neighborhood?',
          answer: 'violence_neighborhood',
        },
        {
          type: 'string',
          questionText: "If yes, please explain:",
          answer: 'violence_neighborhood_information'
        },
        {
          type: 'number',
          questionText: 'Does your child experience people arguing at home?',
          answer: 'home_arguing',
        },
        {
          type: 'string',
          questionText: "If yes, please explain:",
          answer: 'home_arguing_information'
        },
        {
          type: 'string',
          questionText: "What kinds of movies, video game and internet sites does your child like?",
          answer: "movies_video_games",
        },
        {
          type: 'string',
          questionText: "How much time does your child spend watching movies, playing video games, or on the internet?",
          answer: "time_internet",
        },
        {
          type: 'string',
          questionText: "How do you monitor or restrict your child's access to specific materials?",
          answer: "monitor_child_access",
        },
      ]
    },
    {
      sectionName: "History",
      children: [
        {
          type: 'number',
          questionText: 'Has your child ever been hospitalized?',
          answer: 'hospitalization',
        },
        {
          type: 'string',
          questionText: 'If yes, please explain:',
          answer: 'hospitalization_information'
        },
        {
          type: 'number',
          questionText: 'Has your child had any serious medical conditions?',
          answer: 'medical_conditions',
        },
        {
          type: 'string',
          questionText: 'If yes, please explain:',
          answer: 'medical_conditions_information'
        },
        {
          type: 'number',
          questionText: 'Has your child had any recent medical treatment?',
          answer: 'recent_medical_treatment',
        },
        {
          type: 'string',
          questionText: 'If yes, please explain:',
          answer: 'recent_medical_trreatment_information'
        },
        {
          type: 'number',
          questionText: 'Is your child taking any medications, or has he/she been prescribed any medications that he/she is not taking?',
          answer: 'prescribed_medications',
        },
        {
          type: 'string',
          questionText: 'If yes, please explain:',
          answer: 'prescribed_medications_information'
        },
      ]
    },
    {
      sectionName: "Health and Personal Characteristics",
      children: [
        {
          type: 'string',
          questionText: "What has your child's mood been like recently?",
          answer: "child_mood",
        },
        {
          type: 'string',
          questionText: "How would you describe your child's sleep habits?",
          answer: "child_sleep_habits",
        },
        {
          type: 'string',
          questionText: "How would you describe your child's appetite?",
          answer: "child_appetite",
        },
        {
          type: 'string',
          questionText: "How would you describe your child's energy level?",
          answer: "child_energy_level",
        },
        {
          type: 'string',
          questionText: "How would you describe your child's concentration?",
          answer: "child_concentration",
        },
        {
          type: 'number',
          questionText: 'Does he/she follow directions without repetition and reminders?',
          answer: 'follow_directions'
        },
        {
          type: 'string',
          questionText: 'If yes, please explain:',
          answer: 'follow_directions_information'
        },
        {
          type: 'number',
          questionText: 'Does your child say things without thinking?',
          answer: 'say_without_thinking',
        },
        {
          type: 'string',
          questionText: 'If yes, please explain:',
          answer: 'say_without_thinking_information'
        },
        {
          type: 'number',
          questionText: 'Is your child surprised by consequences when he/she is held accountable?',
          answer: 'surprise_consequences',
        },
        {
          type: 'string',
          questionText: 'If yes, please explain:',
          answer: 'surprise_consequences_information'
        },
        {
          type: 'number',
          questionText: 'Has your child been unusually nervous or anxious recently?',
          answer: 'child_anxiety',
        },
        {
          type: 'string',
          questionText: 'If yes, please explain:',
          answer: 'child_anxiety_information'
        },
        {
          type: 'number',
          questionText: 'Has your child been irritable or short-tempered recently?',
          answer: 'child_short_temper',
        },
        {
          type: 'string',
          questionText: 'If yes, please explain:',
          answer: 'child_short_temper_information'
        },
        {
          type: 'number',
          questionText: 'Has your child ever talked about suicide or otherwise hurting himself/herself?',
          answer: 'hurt_child',
        },
        {
          type: 'string',
          questionText: 'If yes, please explain:',
          answer: 'hurt_child_information'
        },
        {
          type: 'number',
          questionText: "Has your child ever said things that didn't make sense or seemed to believe in things that weren't real?",
          answer: 'not_real',
        },
        {
          type: 'string',
          questionText: 'If yes, please explain:',
          answer: 'not_real_information'
        },
        {
          type: 'number',
          questionText: 'Has your child ever seen a counselor or therapist?',
          answer: 'counselor',
        },
        {
          type: 'string',
          questionText: 'If yes, please explain:',
          answer: 'counselor_information'
        },
        {
          type: 'number',
          questionText: 'Has your child had any involvement with other agencies or programs in the community?',
          answer: 'agencies',
        },
        {
          type: 'string',
          questionText: 'If yes, please explain:',
          answer: 'agencies_information'
        },
      ]
    },
    {
      sectionName: "Additional Information",
      children: [
        {
          type: 'number',
          questionText: 'Is there other information regarding your child that you have not yet shared that you believe would be important for the behavioral threat assessment team to consider?',
          answer: 'more_information',
        },
        {
          type: 'string',
          questionText: 'If yes, please explain:',
          answer: 'more_information_information'
        },
        {
          type: 'number',
          questionText: 'If you identified medical, mental health, or other service providers who work with your child, are you willing to sign confidentiality waivers to allow us to discuss your child and this situation directly with that provider?',
          answer: 'confidentiality_waiver',
        },
        {
          type: 'string',
          questionText: 'If yes, please explain:',
          answer: 'confidentiality_waiver_information'
        },
        {
          type: 'number',
          questionText: 'Is there anyone else you believe we should talk to about your child on this situation?',
          answer: 'other_person',
        },
        {
          type: 'string',
          questionText: 'If yes, please explain:',
          answer: 'other_person_information'
        }
      ]
    },
    {
      sectionName: "Official Signature(s)",
      children: [
        {
          type: 'string',
          questionText: "Signature:",
          answer: "user_signature_name"
        },
        {
          type: 'string',
          questionText: "Name:",
          answer: "user_fullname"
        },
        {
          type: 'string',
          questionText: "Email address:",
          answer: "user_email"
        },
        {
          type: 'string',
          questionText: "Title:",
          answer: "user_title"
        },
        {
          type: 'string',
          questionText: "Workphone:",
          answer: "user_workphone"
        },
        {
          type: 'datetime',
          questionText: "Date & Time:",
          answer: "user_signature_date_time"
        }
      ]
    }
  ];

  constructor(
    private parentInterviewService: ParentInterviewService
  ) { }

  ngOnInit(): void {
    this.loadParentInterview();
  }

  loadParentInterview(): void {
    if (this.caseId) {
      this.loading = true;      
      this.parentInterviewService.getParentInterviewByCaseId(this.caseId).subscribe({
        next: (response) => {
          this.parentInterview = response;
          this.loading = false;
        },
        error: (error) => {
          console.error('Error fetching parent interview:', error);
          this.loading = false;
        }
      });
    }
  }

  showYesNo(answer: number): string {
    switch (answer) {
      case 0: return 'No';
      case 1: return 'Yes';
      case 2: return 'Need More Information';
      default: return 'N/A';
    }
  }

}
